module.exports = __webpack_public_path__ + "fonts/ubuntu-v14-latin-700.7b253bf.woff2";